import * as Request from "common/utils/serverRequest";
import * as ServerHelper from "common/utils/serverHelper";
import * as serverPaths from "common/utils/serverPaths";
//-------------------------------------------------------------------------------------------------------------------------------
export function async_activeListingsRequest(dispatch, officeId, date = null) {
    if (!date) {
        return Request.getComponentJson(dispatch, serverPaths.activeListingsRequest(officeId))
            .then((response) => handleActiveListingsResponseSuccess(response), (error) => ServerHelper.handleResponseFailure(error));
    }
    else {
        return Request.getComponentJson(dispatch, serverPaths.activeListingsRequestWithDate(officeId, date))
            .then((response) => handleActiveListingsResponseSuccess(response), (error) => ServerHelper.handleResponseFailure(error));
    }
}
function handleActiveListingsResponseSuccess(response) {
    return response.json()
        .then((json) => {
        return Promise.resolve(json);
    }, () => {
        return Promise.reject("Unknown error interpreting response (1)");
    });
}
//-------------------------------------------------------------------------------------------------------------------------------
